<template>
  <svg :x="captionX" :y="captionYMinusFontSize" :width="`${captionWidth}in`" :height="`${captionHeight}in`" xmlns="http://www.w3.org/2000/svg" overflow="visible">
    <g class="mat-caption">
      <text
        v-for="(line, index) in captionLines"
        :key="index"
        :class="`line${index + 1}`"
        :font-size="line.fontSize"
        :letter-spacing="line.letterSpacing"
        :text-anchor="line.textAnchor"
        :x="line.x"
        :y="line.y"
        :font-family="line.fontFamily"
        :fill="line.fill"
        :stroke="line.stroke"
        :stroke-width="line.strokeWidth"
        font-weight="500"
      >
        {{ line.message }}
      </text>
    </g>
  </svg>
</template>

<script>
import { matCaption as matCaptionValues } from "../../hardCodedValues";

export default {
  props: {
    frameSpec: {
      type: Object,
      required: true
    },
    captionX: {
      type: Number,
      required: true
    },
    captionY: {
      type: Number,
      required: true
    },
    captionWidth: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      firstLineLineSpacing: 0
    }
  },
  computed: {
    fullMat () {
      return this.frameSpec.getFullPrimaryMat();
    },
    captionYMinusFontSize() {
      return this.captionY - this.firstLineLineSpacing;
    },
    matCaption() {
      return this.frameSpec.mats[0].matCaption || null;
    },
    captionLines() {
      if (!this.matCaption) return [];

      const lines = this.matCaption.lines || this.matCaption.message;
      const lineKeys = Object.keys(lines).filter(key => {
        return lines[key].message || lines[key].message === "";
      });

      let firstLineFontSize;

      return lineKeys.map((key, index) => {
        const line = lines[key];
        const fontValues = matCaptionValues.fonts[line.fontStyle] || matCaptionValues.fonts["apercu"];
        const fontSize = line.fontSize === 'large' ? fontValues.largeFontSize : fontValues.fontSize;
        const letterSpacing = line.fontSize === 'large' ? fontValues.largeLetterSpacing : fontValues.letterSpacing;
        const lineSpacing = line.fontSize === 'large' ? fontValues.largeLineSpacing : fontValues.lineSpacing;
        if (index === 0) {
          firstLineFontSize = fontSize;
          this.firstLineLineSpacing = lineSpacing;
        }

        let yOffset;

        if (index === 0) {
          yOffset = this.firstLineLineSpacing + lineSpacing;
        } else if (index === 1) {
          if (index >= 1 && this.matCaption.layoutName === 'title-with-subtext') {
            yOffset = this.firstLineLineSpacing + fontValues.fontSize + (firstLineFontSize / 2) + lineSpacing;
          } else {
            yOffset = this.firstLineLineSpacing + fontValues.fontSize + lineSpacing * 2
          }
        } else if (index === 2) {
          yOffset = this.firstLineLineSpacing + fontSize * 2 + lineSpacing * 3
        } else {
          yOffset = this.firstLineLineSpacing + fontSize * 3 + lineSpacing * 4
        }

        const captionColor = this.matColorCategory === 'dark' ? fontValues.darkMatFontColor : fontValues.fontColor;
        
        return {
          message: line.message,
          fontSize: `${fontSize}`,
          letterSpacing: `${letterSpacing}`,
          textAnchor: this.getTextAnchor(line.fontAlignment),
          x: this.getCaptionX(line.fontAlignment),
          y: yOffset,
          fontFamily: line.fontStyle,
          fill: captionColor,
          stroke: captionColor,
          strokeWidth: `${fontValues.strokeWidth}`
        };
      });
    },
    captionHeight() {
      return matCaptionValues.maxHeight; // Assuming max height for captions
    },
    matColorCategory() {
      if (this.fullMat && this.fullMat.captionCategory) {
        return this.fullMat.captionCategory;
      } else {
        return "light"; // Default to light if value missing
      }
    }
  },
  methods: {
    getTextAnchor(alignment) {
      switch (alignment) {
        case 'left':
          return 'start';
        case 'right':
          return 'end';
        default:
          return 'middle';
      }
    },
    getCaptionX(alignment) {
      switch (alignment) {
        case 'left':
          return 0;
        case 'right':
          return this.captionWidth;
        default:
          return this.captionWidth / 2;
      }
    }
  }
};
</script>

<style scoped>
/* No styles needed */
</style>